import React, { useEffect, useState } from 'react'
import useAxios from '../../../lib/auth/useAxios'
import { Table, Label, Button, Modal } from 'semantic-ui-react'
import MickeyForm from '../../../components/Forms/MickeyForm'
import './AdminFulfillment.css'
import MickeyTable from '../../../components/MickeyTable/MickeyTable'
import PageHeader from '../../../components/PageHeader/PageHeader'
import { toast } from 'react-toastify'
import { hasPermission } from '../../../lib/utils/utils'
import { useSelector } from 'react-redux'
import env from '../../../env'

function AdminFulfillmentTruckingCompanies(props) {
  const tenant = useSelector((state) => {
    return state?.globals?.tenant
  })
  const [reload, setReload] = useState(false)
  const [addTruckingUserModalOpen, setAddTruckingUserModalOpen] = useState()
  const user = useSelector((state) => state.user.user)
  const business = useSelector((state) => state.user.business)
  const axios = useAxios()

  const addToSubmit = () => {
    setAddTruckingUserModalOpen(false)
    setReload(true)
  }

  return (
    <div style={{ padding: 0, marginTop: '0px' }}>
      <PageHeader
        icon={'truck'}
        header={'Fulfillment Companies'}
        buttons={
          hasPermission(user, 'Create Business')
            ? [
                {
                  color: 'primary',
                  content: 'Add Fulfillment Company',
                  onClick: () => {
                    setAddTruckingUserModalOpen(true)
                  },
                  style: {
                    '--primaryColor': tenant?.deployment_primary_color,
                    '--secondaryButtonColor':
                      env.REACT_APP_SECONDARY_BUTTON_COLOR,
                  },
                },
              ]
            : []
        }
      />
      <MickeyTable
        headerRow={['Company Name', 'Contact Name', 'Email', 'Phone']}
        url={'/main/admin-trucking-companies/'}
        reload={reload}
        setReload={setReload}
        basicSegment
        renderBodyRow={(data, index) => {
          return (
            <Table.Row>
              <Table.Cell>{data?.name}</Table.Cell>
              <Table.Cell>
                {data?.contact_first_name} {data?.contact_last_name}
              </Table.Cell>
              <Table.Cell>{data?.email}</Table.Cell>
              <Table.Cell>{data?.phone}</Table.Cell>
            </Table.Row>
          )
        }}
        emptyIcon={'truck'}
        emptyMessage={'Trucking companies will populate here'}
      />
      <Modal
        onClose={() => setAddTruckingUserModalOpen(false)}
        onOpen={() => setAddTruckingUserModalOpen(true)}
        open={addTruckingUserModalOpen}
      >
        <Modal.Header>Add Fulfillment Company</Modal.Header>
        <Modal.Content>
          <MickeyForm
            formName={'TruckingCompanyForm'}
            model={'TruckingCompany'}
            url={'/main/admin-trucking-companies/'}
            addToSubmit={() => addToSubmit()}
            handleForm={() => {
              setReload(true)
            }}
          />
        </Modal.Content>
      </Modal>
    </div>
  )
}

export default AdminFulfillmentTruckingCompanies
